import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InlineSvgDirective } from '../inline-svg/inline-svg.directive';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InlineSvgDirective],
})
export class IconComponent {
  @Input()
  public svgPath: string;

  @Input()
  public size: string;

  @Input()
  public verticalSize: string;

  public svg: string;
  public sizeClass: string;
}
